/**
 * Awvent - Awvent Users API
 * Awvent User Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Salutation } from '../../enums/common/salutation.enum';
import { EmailAddressDto } from '../common/email-address.dto';
import { PhoneNumberDto } from '../common/phone-number.dto';
import { TenantCompactDto } from './tenant-compact.dto';

export class UserDto {
    id?: string;
    uId?: string;
    salutation?: Salutation;
    firstName?: string;
    lastName?: string;
    displayName?: string;
    email?: EmailAddressDto;
    emailVerified?: boolean;
    mobileNumber?: PhoneNumberDto;
    photoUrl?: string;
    disabled?: boolean;
    createdTime?: Date;
    tenants?: Array<TenantCompactDto>;
}
